const rocketData = [
  [1.00369, 51.3557],
  [1.17774, 51.3253],
  [1.28874, 51.0784],
  [1.2946, 51.349],
  [1.0994, 51.379],
  [0.7902, 51.313934],
  [0.877792, 51.39416],
  [0.740767, 51.410878],
  [0.820856, 51.453306],
  [0.63485, 51.426786],
  [0.62409, 51.445585],
  [0.57914, 51.454911],
  [0.568453, 51.466108],
  [0.50612, 51.432697],
  [0.562233, 51.481653],
  [0.63156, 51.476307],
  [0.658013, 51.480028],
  [0.469811, 51.400343],
  [0.474533, 51.315061],
  [0.492968, 51.290359],
  [0.427627, 51.225353],
  [0.475305, 51.200498],
  [0.579533, 51.078477],
  [0.358619, 51.001708],
  [0.178012, 51.02318],
  [0.250311, 50.814482],
  [0.242088, 51.16527],
  [0.261749, 51.187238],
  [0.171719, 51.16694],
  [0.154506, 51.186672],
  [0.151739, 51.206194],
  [0.060967, 51.118494],
  [-0.132281, 51.210674],
  [-0.002754, 51.245921],
  [-0.798828, 51.130076],
  [-0.852943, 51.525605],
  [0.167175, 51.256521],
  [0.155629, 51.26556],
  [0.130993, 51.256559],
  [0.198537, 51.285854],
  [0.213333, 51.292166],
  [0.492479, 51.290158],
  [0.474781, 51.315198],
  [0.286371, 51.290621],
  [0.283074, 51.279815],
  [0.321805, 51.279404],
  [0.077906, 51.272936],
  [0.08336, 51.300037],
  [0.018157, 51.295129],
  [-0.036186, 51.294854],
  [0.019012, 51.332446],
  [0.002245, 51.348399],
  [-0.033489, 51.344324],
  [-0.092191, 51.343111],
  [-0.077614, 51.359268],
  [-0.074491, 51.367382],
  [0.016001, 51.376149],
  [1.785626, 51.520976],
  [1.670885, 51.598946],
  [1.414563, 51.483655],
  [1.290665, 51.501392],
  [1.224133, 51.502511],
  [0.140403, 51.340747],
  [0.152094, 51.354905],
  [0.108095, 51.363422],
  [0.095374, 51.375362],
  [0.09969, 51.374498],
  [0.109742, 51.379633],
  [0.119961, 51.381263],
  [0.078481, 51.383541],
  [0.054089, 51.390142],
  [0.151627, 51.37912],
  [0.158472, 51.381875],
  [0.160214, 51.388322],
  [0.178726, 51.381597],
  [0.212945, 51.379514],
  [0.208081, 51.399616],
  [0.219867, 51.401179],
  [0.184964, 51.400427],
  [0.250324, 51.405112],
  [0.284284, 51.393964],
  [0.274719, 51.409372],
  [0.28322, 51.41461],
  [0.272539, 51.432023],
  [0.300187, 51.443806],
  [0.281745, 51.451377],
  [0.324328, 51.43804],
  [0.373037, 51.40306],
  [0.373020, 51.430204],
  [0.376366, 51.442841],
  [0.443667, 51.457331],
  [2.697464, 52.192020],
  [2.468602, 52.038223],
  [2.013093, 52.286204],
  [1.537340, 52.35802],
  [1.597493, 51.940058],
  [1.689110, 51.843538],
  [1.578059, 51.801209],
  [1.365738, 52.018597],
  [1.306680, 51.982842],
  [1.287049, 51.948370],
  [1.444539, 52.116648],
  [1.458546, 52.286346],
  [1.205637, 52.069169],
  [1.226351, 52.075777],
  [0.957580, 52.018729],
  [0.127670, 51.393921],
  [0.141632, 51.393594],
  [0.148777, 51.399033],
  [0.152448, 51.401691],
  [0.107808, 51.395557],
  [0.090437, 51.411750],
  [0.077589, 51.411260],
  [0.166565, 51.410328],
  [0.183815, 51.410338],
  [0.148444, 51.423751],
  [0.140906, 51.428001],
  [0.174140, 51.429677],
  [0.140119, 51.439934],
  [0.128910, 51.434622],
  [0.108323, 51.425530],
  [0.102591, 51.425799],
  [0.080871, 51.421451],
  [0.089899, 51.432863],
  [0.085705, 51.435547],
  [0.107594, 51.437336],
  [0.102738, 51.439193],
  [0.094185, 51.446412],
  [0.098998, 51.451612],
  [0.097482, 51.453490],
  [0.094519, 51.452514],
  [0.106152, 51.455517],
  [0.113343, 51.459796],
  [0.084761, 51.460090],
  [0.081639, 51.463036],
  [0.086412, 51.465425],
  [0.137411, 51.456926],
  [0.162516, 51.450175],
  [0.182586, 51.437504],
  [0.186671, 51.441783],
  [0.185001, 51.456019],
  [0.185659, 51.464179],
  [0.214322, 51.460236],
  [0.211692, 51.472568],
  [0.233456, 51.469260],
  [0.243000, 51.461619],
  [0.365503, 51.453905],
  [0.334091, 51.464045],
  [0.394164, 51.481495],
  [0.387992, 51.488382],
  [0.327634, 51.489357],
  [0.304651, 51.495005],
  [0.287544, 51.497112],
  [0.233949, 51.492128],
  [0.312302, 51.503871],
  [0.498709, 51.496334],
  [0.509531, 51.506309],
  [0.531590, 51.507086],
  [0.574045, 51.505662],
  [0.543244, 51.514599],
  [0.537567, 51.516183],
  [0.538700, 51.519620],
  [0.499214, 51.520689],
  [0.494892, 51.523305],
  [0.476438, 51.520689],
  [0.460784, 51.516485],
  [0.514028, 51.529984],
  [0.520624, 51.533592],
  [0.509282, 51.541696],
  [0.505198, 51.542657],
  [0.495044, 51.540140],
  [0.464804, 51.536159],
  [0.553911, 51.538441],
  [0.543342, 51.537749],
  [0.545885, 51.542643],
  [0.553116, 51.544570],
  [0.614498, 51.534050],
  [0.573101, 51.556082],
  [0.616434, 51.578908],
  [0.658595, 51.564622],
  [0.715276, 51.532358],
  [0.674817, 51.504013],
  [0.815915, 51.548798],
  [0.841388, 51.549008],
  [0.796537, 51.568656],
  [0.799514, 51.579460],
  [0.845729, 51.578204],
  [0.908294, 51.580195],
  [0.900759, 51.595715],
  [0.879743, 51.598008],
  [0.875397, 51.604147],
  [0.874087, 51.605330],
  [0.865038, 51.601817],
  [0.935955, 51.616473],
  [0.981641, 51.614726],
  [0.950664, 51.632087],
  [0.908127, 51.628334],
  [0.866906, 51.639483],
  [1.543694, 52.040592],
  [1.039792, 52.206227],
  [1.012197, 52.233707],
  [1.201237, 52.334284],
  [1.320311, 52.455051],
  [1.351608, 52.468563],
  [-0.186945, 51.338855],
  [-0.177006, 51.296575],
  [-0.285046, 51.304137],
  [-0.330982, 51.383390],
  [-0.321885, 51.419505],
  [-0.288628, 51.419677],
  [-0.410567, 51.423949],
  [-0.466672, 51.433258],
  [-0.434996, 51.469122],
  [-0.390514, 51.475123],
  [-0.472461, 51.382482],
  [-0.596407, 51.424904],
  [-0.624046, 51.372469],
  [-0.440707, 51.525059],
  [-0.414897, 51.521848],
  [-0.531328, 51.544773],
  [-0.581715, 51.553725],
  [-0.463436, 51.569177],
  [-0.376312, 51.568719],
  [-0.369043, 51.591654],
  [-0.306566, 51.590233],
  [-0.312423, 51.602292],
  [-0.323146, 51.621404],
  [-0.268212, 51.579383],
  [-0.250616, 51.589853],
  [-0.255633, 51.562253],
  [-0.270834, 51.553058],
  [-0.270628, 51.532669],
  [-0.294365, 51.513104],
  [-0.321725, 51.484537],
  [-0.279800, 51.477860],
  [-0.264445, 51.482385],
  [-0.239834, 51.488172],
  [-0.239678, 51.507226],
  [-0.214815, 51.513150],
  [-0.212986, 51.548336],
  [-0.198186, 51.546487],
  [-0.209473, 51.581821],
  [-0.175144, 51.590744],
  [-0.172866, 51.642255],
  [-0.203006, 51.661312],
  [-0.176470, 51.690087],
  [-0.252806, 51.677345],
  [-0.262079, 51.705518],
  [-0.382558, 51.693099],
  [-0.553043, 51.828033],
  [-0.427285, 51.889631],
  [-0.282017, 52.019583],
  [-0.153874, 51.982600],
  [-0.101417, 51.907812],
  [-0.170929, 51.863075],
  [-0.118233, 51.860860],
  [-0.121345, 51.848551],
  [-0.156993, 51.847192],
  [-0.149580, 51.838132],
  [-0.099877, 51.797029],
  [-0.092443, 51.808053],
  [-0.107238, 51.808097],
  [-0.096516, 51.825897],
  [-0.090038, 51.775921],
  [-0.126971, 51.766767],
  [-0.060023, 51.768297],
  [-0.017419, 51.784620],
  [-0.017886, 51.781112],
  [0.016095, 51.823532],
  [-0.025496, 51.392129],
  [-0.046101, 51.394578],
  [-0.069561, 51.400700],
  [-0.038442, 51.412890],
  [-0.037229, 51.417697],
  [-0.071823, 51.426288],
  [-0.070098, 51.430955],
  [-0.062639, 51.433670],
  [-0.060333, 51.434180],
  [-0.099455, 51.435841],
  [-0.144307, 51.432654],
  [-0.169333, 51.424765],
  [-0.180566, 51.430975],
  [-0.267106, 51.444517],
  [0.026152, 51.418397],
  [0.035487, 51.412851],
  [0.044570, 51.412497],
  [0.051884, 51.408145],
  [0.055489, 51.425220],
  [0.065274, 51.426237],
  [0.065446, 51.434023],
  [0.007953, 51.436379],
  [0.003692, 51.438504],
  [0.011115, 51.441722],
  [0.010853, 51.443611],
  [0.026596, 51.439748],
  [0.058519, 51.444944],
  [0.064044, 51.442512],
  [0.061338, 51.452532],
  [0.050489, 51.453973],
  [0.076326, 51.440471],
  [0.078616, 51.445789],
  [0.074453, 51.455419],
  [0.081945, 51.453117],
  [0.066025, 51.462777],
  [0.058325, 51.466181],
  [0.052394, 51.464754],
  [0.041889, 51.463437],
  [0.038195, 51.464345],
  [0.037830, 51.469563],
  [0.049124, 51.471107],
  [0.046330, 51.472967],
  [0.024797, 51.476898],
  [0.023291, 51.470641],
  [0.010325, 51.467262],
  [0.010221, 51.473387],
  [0.014695, 51.476757],
  [0.001897, 51.482330],
  [-0.007965, 51.480515],
  [-0.011408, 51.479605],
  [-0.016963, 51.481616],
  [-0.014097, 51.470360],
  [-0.024534, 51.458283],
  [-0.035251, 51.454037],
  [-0.041182, 51.451151],
  [-0.048674, 51.449627],
  [-0.047530, 51.457894],
  [-0.042119, 51.463405],
  [-0.033794, 51.463470],
  [-0.047599, 51.467520],
  [-0.035778, 51.470960],
  
]

export default rocketData;
